export const WELCOME = 'ModalContentTypes.WELCOME'
export const WELCOME_REGISTRATION = 'ModalContentTypes.WELCOME_REGISTRATION'
export const REGISTRATION = 'ModalContentTypes.REGISTRATION'
export const CTA_PROMPT = 'ModalContentTypes.CTA_PROMPT'

export default {
    WELCOME,
    WELCOME_REGISTRATION,
    REGISTRATION,
    CTA_PROMPT,
}
